function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { Icon } from '@signicat/designi/components/icons';
import { Segment } from '@signicat/designi/components/containers';
import { Row, Column } from '@signicat/designi/components/layout';
import { media } from '@signicat/designi/helpers/responsive';
import { isEqual } from 'lodash';
import SignerEdit from "./SignerEdit";
import { orders as ordersActions } from "../../../store/actions";
var StyledIcon = styled(Icon).withConfig({
  displayName: "Signer__StyledIcon",
  componentId: "sc-8qvvqp-0"
})(["margin:0 10px;cursor:pointer;"]);
var Signer = function Signer(props) {
  var _recipient$data, _recipient$data2, _recipient$data3, _recipient$data4;
  var recipient = props.recipient,
    isDraggable = props.isDraggable;
  var dispatch = useDispatch();
  var _useState = useState(Boolean(recipient.isNew)),
    _useState2 = _slicedToArray(_useState, 2),
    editMode = _useState2[0],
    setEditMode = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    originalRecipient = _useState4[0],
    setOriginalRecipient = _useState4[1];
  var handleEditClick = function handleEditClick() {
    setOriginalRecipient(recipient);
    setEditMode(true);
  };
  var handleEditDone = function handleEditDone(signerData) {
    //save it only if anything has changed
    if (signerData && recipient.isDirty) {
      dispatch(ordersActions.saveSigner('create', recipient.id)).then(function (signer) {
        setEditMode(false);
      })["catch"](function (err) {
        console.error(err);
      });
    } else {
      if (recipient.isNew) {
        dispatch({
          type: 'REMOVE_RECIPIENT',
          id: recipient.id
        });
      } else {
        setEditMode(false);
      }
    }
  };
  var removeSigner = function removeSigner() {
    // TODO: Fix hard coded create
    dispatch(ordersActions.removeSigner('create', recipient.id))
    // .catch((err) => {
    //   // TODO: Show error message
    //   console.error('error in view', err);
    //   throw new Error('Error when removing signer');
    // })
    .then(function () {
      // TODO: Move this to removeSigner action
      dispatch({
        type: 'REMOVE_RECIPIENT',
        id: recipient.id
      });
    });
  };
  var handleEditCancel = function handleEditCancel() {
    if (recipient.isNew) {
      dispatch({
        type: 'REMOVE_RECIPIENT',
        id: recipient.id
      });
    } else {
      dispatch({
        type: 'UPDATE_RECIPIENT',
        id: recipient.id,
        recipient: _objectSpread(_objectSpread({}, originalRecipient), {}, {
          isDirty: false
        })
      });
    }
    setEditMode(false);
  };
  var handleEditChange = function handleEditChange(signerData) {
    if (!isEqual(signerData, recipient.data)) {
      dispatch({
        type: 'UPDATE_RECIPIENT',
        id: recipient.id,
        recipient: _objectSpread(_objectSpread({}, recipient), {}, {
          data: _objectSpread({}, signerData),
          isDirty: true
        })
      });
    }
  };
  var recipientStringRepresentation = recipient !== null && recipient !== void 0 && (_recipient$data = recipient.data) !== null && _recipient$data !== void 0 && _recipient$data.firstName && recipient !== null && recipient !== void 0 && (_recipient$data2 = recipient.data) !== null && _recipient$data2 !== void 0 && _recipient$data2.lastName ? "".concat(recipient === null || recipient === void 0 ? void 0 : (_recipient$data3 = recipient.data) === null || _recipient$data3 === void 0 ? void 0 : _recipient$data3.firstName, " ").concat(recipient === null || recipient === void 0 ? void 0 : (_recipient$data4 = recipient.data) === null || _recipient$data4 === void 0 ? void 0 : _recipient$data4.lastName) : recipient.data.email || recipient.data.mobileNumber;
  useEffect(function () {
    if (!recipient.isNew && !recipient.isDirty) {
      setEditMode(false);
    }
  }, [recipient.isNew, recipient.isDirty]);
  return editMode === true ? /*#__PURE__*/React.createElement(SignerEdit, {
    testSelector: "signer-id-".concat(recipient.id),
    signerId: recipient.id,
    signer: recipient,
    removeSigner: removeSigner,
    onDone: handleEditDone,
    onChange: handleEditChange,
    onCancel: handleEditCancel,
    requiredDisabled: isDraggable
  }) : /*#__PURE__*/React.createElement(Segment, {
    outlined: true,
    testSelector: "signer-id-".concat(recipient.id)
  }, /*#__PURE__*/React.createElement(Row, {
    vertical: "center",
    horizontal: "space-between"
  }, /*#__PURE__*/React.createElement(Column, {
    direction: "row",
    flex: "0 0 auto"
  }, isDraggable && /*#__PURE__*/React.createElement(StyledIcon, {
    name: "menu"
  }), /*#__PURE__*/React.createElement(Icon, {
    name: "signer"
  })), /*#__PURE__*/React.createElement(Column, {
    direction: "row"
  }, /*#__PURE__*/React.createElement("div", null, recipientStringRepresentation)), /*#__PURE__*/React.createElement(Column, {
    direction: "row",
    flex: "0 0 auto"
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    name: 'edit',
    onClick: handleEditClick
  }), /*#__PURE__*/React.createElement(StyledIcon, {
    name: 'cancel',
    onClick: removeSigner
  }))));
};
export default Signer;